import { Dropdown, DropdownButton } from "@similarweb/ui-components";

import { PlainTooltip } from "app/components/React/Tooltip/PlainTooltip/PlainTooltip";
import { translate } from "app/filters/i18nFilter";
import type { DropdownItemProps } from "app/pages/sales-intelligence/modules/enrichment/components/type";
import { DD_WIDTH } from "app/pages/sales-intelligence/modules/enrichment/constants/constants";
import {
    StyledDropdownItem,
    StyledTextWrapper,
} from "app/pages/sales-intelligence/modules/enrichment/containers/EnrichmentCsvContainer/style";
import type { EnrichmentType } from "app/pages/sales-intelligence/modules/enrichment/types/types";
import {
    DISABLED_TOOLTIP_CONTENT,
    HEADER_SELECTION_ERROR,
    PLACEHOLDER_TEXT,
} from "app/pages/sales-intelligence/modules/enrichment/utils/i18n/modal.texts";
import enrichmentTrackingService from "app/pages/sales-intelligence/services/tracking/enrichment/trackingService";

type HeadersDropdownProps = {
    setSelectedHeader: (id: string) => void;
    selectedHeader: string | undefined;
    headerNames: string[];
    type: EnrichmentType;
    appendTo?: string;
    disabledTooltipText?: string;
    getIsOptionDisabled?: (header: string) => boolean;
    isError?: boolean;
    eventName?: string;
    onToggle?: () => void;
};

export const HeadersDropdown = ({
    setSelectedHeader,
    selectedHeader,
    headerNames,
    appendTo,
    disabledTooltipText = DISABLED_TOOLTIP_CONTENT,
    getIsOptionDisabled,
    isError = false,
    eventName = "website column",
    onToggle,
    type,
}: HeadersDropdownProps) => {
    const onHeaderSelect = ({ id, disabled }: DropdownItemProps) => {
        if (!disabled) {
            enrichmentTrackingService.csv.trackSelectHeaderMap(eventName, id, type);
            setSelectedHeader(id);
        }
    };

    const headerOptions = [
        <DropdownButton
            key="header-dd-btn"
            width={DD_WIDTH}
            error={isError}
            errorText={translate(HEADER_SELECTION_ERROR)}
        >
            {selectedHeader ?? translate(PLACEHOLDER_TEXT)}
        </DropdownButton>,
        ...headerNames.map((header, idx) => {
            const isDisabled = getIsOptionDisabled?.(header) ?? false;
            const className = `header-dropdown-item-${idx}`;

            return (
                <StyledDropdownItem
                    className={className}
                    key={idx}
                    id={header}
                    disabled={isDisabled}
                >
                    <PlainTooltip
                        enabled={isDisabled}
                        maxWidth={350}
                        text={translate(disabledTooltipText)}
                    >
                        <StyledTextWrapper>{header}</StyledTextWrapper>
                    </PlainTooltip>
                </StyledDropdownItem>
            );
        }),
    ];

    return (
        <Dropdown
            appendTo={appendTo}
            selectedIds={selectedHeader ? { [selectedHeader]: true } : undefined}
            onClick={onHeaderSelect}
            dropdownPopupPlacement="ontop-left"
            onToggle={onToggle}
        >
            {...headerOptions}
        </Dropdown>
    );
};
